/* Copyright (c) 2024 Xperi. All Rights Reserved. */

import React, { FunctionComponent } from 'react';

import { Mousetrap } from '../../../common';
import { OptionListInteractiveLayer } from './OptionListInteractiveLayer';

import './OptionList.scss';

interface OptionListProps {
    text: string;
    options: Array<string>;
    isFocused: boolean;
    id: number;
    horizontalPosition: number;
    verticalPosition?: number;
    isGhostModeEnabled?: boolean;
    iconUrl?: string;
}

const OptionList: FunctionComponent<OptionListProps> = (props): JSX.Element => {
    const { text, options, isFocused, id, horizontalPosition, isGhostModeEnabled, iconUrl } = props;

    const createOptionList = () => {
        return (
            <>
                <OptionListInteractiveLayer focused={isFocused} />
                <Mousetrap
                    value={id}
                    className={`scrolling-pill ${isFocused ? `highlighted ${isGhostModeEnabled ? 'ghost-highlight' : null}` : ''} 
        `}
                >
                    <div className={`left-arrow ${isFocused ? 'highlighted' : 'ghost'}`}></div>
                    <div className={`pill-text`}>{options[horizontalPosition]}</div>
                    {iconUrl ? <div className="lock-icon"></div> : ''}
                    <div className={`right-arrow ${isFocused ? 'highlighted' : 'ghost'}`}></div>
                </Mousetrap>
            </>
        );
    };
    return (
        <div className="option-list-container">
            <div className="list-title">{text}</div>
            {createOptionList()}
        </div>
    );
};

export default OptionList;
